import {
  editPrelaunchCompanyPaymentDetail,
  getPrelaunchCompanyPaymentDetail,
} from '../../../api/prelaunchOrganizationFormsApi'
import PaymentDetailForm from '../../../components/common/payment-detail-form'
import { convertCompanyPaymentDetailToFormValues } from '../../../helpers/prelaunch-organization-helper'
import translate from '../../../i18n'
import { PrelaunchCompanyPaymentDetailFormValues } from '../share-types'
import { notification } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const PrelaunchCompanyPaymentDetailForm = () => {
  const navigate = useNavigate()
  const params = useParams()
  const [prelaunchCompanyPaymentDetailId] = useState<string | undefined>(
    params?.prelaunchCompanyPaymentDetailId,
  )
  const [prelaunchOrganizationId] = useState<string | undefined>(params?.id)
  const [prelaunchCompanyPaymentDetailFormData, setPrelaunchCompanyPaymentDetailFormData] =
    useState<PrelaunchCompanyPaymentDetailFormValues>()

  useEffect(() => {
    if (prelaunchCompanyPaymentDetailId) {
      getPrelaunchCompanyPaymentDetail(prelaunchCompanyPaymentDetailId).then(data => {
        setPrelaunchCompanyPaymentDetailFormData(convertCompanyPaymentDetailToFormValues(data))
      })
    }
  }, [prelaunchCompanyPaymentDetailId])

  const onFinish = (value: PrelaunchCompanyPaymentDetailFormValues) => {
    if (!prelaunchCompanyPaymentDetailId) {
      return
    }

    editPrelaunchCompanyPaymentDetail(prelaunchCompanyPaymentDetailId, value)
      .then(response => {
        if (response) {
          notification.success({
            title: 'Edit Company Payment Detail Success',
          })
          navigate(`/prelaunch-organization-forms/${prelaunchOrganizationId}`)
        }
      })
      .catch(err => {
        notification.error({
          message: 'Edit  Company Payment Detail Failed',
          description: err?.message || translate('networkError'),
        })
      })
  }

  return <PaymentDetailForm onFinish={onFinish} formData={prelaunchCompanyPaymentDetailFormData} />
}

export default PrelaunchCompanyPaymentDetailForm
